<style>
.echarts {
  width: 100%;
  height: 100%;
}

.active_table {
  width: 100%;
  height: 100%;
}

.ch {
  width: 80vw;
  height: 80vh;
  margin: 0 auto;
}
</style>

<template>
  <div class="active_table">
    <toolbar>
      <div class="search">
        <DatePicker type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 200px;margin-left: 10px"
          @on-change="dateSelect($event)"></DatePicker>
        <i-button type="default" @click="searchFunc" style="margin-left: 1em;">搜索</i-button>
      </div>
    </toolbar>
    <div class="ch">
      <div>
        <h1>设备告警时长</h1>
      </div>
      <div>
        <v-chart autoresize :options="orgOptions" style="height: 60vh" />
      </div>
      <p></p>
    </div>
  </div>
</template>
 
<script>
import toolbar from "../toolBar.vue"; // 操作栏组件

export default {
  data() {
    return {
      orgOptions: {},
      // 查询
      search: {
        startDate: null,
        endDate: null,
      },
    };
  },
  components: {
    toolbar
  },
  created: function () {
    this.getData();
  },
  methods: {
    getData() {
      var that = this;
      // 获取数据
      this.$api.BigData.getChart2({ content: this.search }, [
        "uuid",
        "company",
      ]).then((res) => {
        if (res.code == 0) {
          // 获取成功
          let warnData = res.data; //数据
          let dateList = []; // 标题
          let dataList = []; // 数据值
          warnData.map((res) => {
            dateList.push(res.date);
            dataList.push(res.count);
            //console.log(res.date);
          });

          this.orgOptions = {
            color: ["#3398DB"],
            tooltip: {
              trigger: "axis",
              formatter: function (params) {
                return (
                  params[0].name +
                  "<br/>合计告警时长:" +
                  that.formatSeconds(params[0].value)
                );
              },
              axisPointer: {
                // 坐标轴指示器，坐标轴触发有效
                type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
              },
            },
            toolbox: {
              show: true,
              feature: {
                saveAsImage: {},
              },
            },
            grid: {
              left: "3%",
              right: "4%",
              bottom: "3%",
              containLabel: true,
            },
            xAxis: [
              {
                type: "category",
                name: "站点设备",
                boundaryGap: true,
                axisLabel: {
                  //底部文字倾斜
                  interval: 0,
                  rotate: 25,
                  // formatter: function (value, index) {
                  //   return index % 10 === 0 ? value : '';
                  // }
                },
                data: dateList,
              },
            ],
            yAxis: [
              {
                type: "value",
              },
            ],
            series: [
              {
                name: "设备告警时长",
                type: "bar",
                barWidth: "60%",
                data: dataList,
              },
            ],
            dataZoom: [
              {
                // 设置滚动条的隐藏与显示
                show: true,
                // 设置滚动条类型
                type: "slider",
                // 设置背景颜色
                backgroundColor: "rgb(19, 63, 100)",
                // 设置选中范围的填充颜色
                fillerColor: "rgb(16, 171, 198)",
                // 设置边框颜色
                borderColor: "rgb(19, 63, 100)",
                // 是否显示detail，即拖拽时候显示详细数值信息
                showDetail: false,
                // 数据窗口范围的起始数值
                startValue: 0,
                // 数据窗口范围的结束数值（一页显示多少条数据）
                endValue: 20,
                // empty：当前数据窗口外的数据，被设置为空。
                // 即不会影响其他轴的数据范围
                filterMode: "empty",
                // 设置滚动条宽度，相对于盒子宽度
                width: "95%",
                // 设置滚动条高度
                height: 12,
                // 设置滚动条显示位置
                left: "center",
                // 是否锁定选择区域（或叫做数据窗口）的大小
                zoomLoxk: true,
                // 控制手柄的尺寸
                handleSize: 0,
                // dataZoom-slider组件离容器下侧的距离
                bottom: 3,
              },
              {
                // 没有下面这块的话，只能拖动滚动条，
                // 鼠标滚轮在区域内不能控制外部滚动条
                type: "inside",
                // 滚轮是否触发缩放
                zoomOnMouseWheel: false,
                // 鼠标滚轮触发滚动
                moveOnMouseMove: true,
                moveOnMouseWheel: true,
              },
            ],
          };
          this.$Message.success("加载完成");
        } else {
          this.$Message.warning(res.message);
        }
      });
    },
    // 选择时间
    dateSelect(date) {
      this.search.startDate = new Date(date[0]).setHours("0");
      this.search.endDate = new Date(date[1]).setHours("24");
      //console.log(this.search);
    },
    // 搜索
    searchFunc() {
      this.getData();
    },
    formatSeconds(value) {
      var theTime0 = parseInt(value); // 需要转换的时间分
      var theTime1 = 0; // 小时
      var theTime2 = 0; // 天
      if (theTime0 > 60) {
        theTime1 = parseInt(theTime0 / 60);
        theTime0 = parseInt(theTime0 % 60);
        if (theTime1 > 24) {
          //大于24小时
          theTime2 = parseInt(theTime1 / 24);
          theTime1 = parseInt(theTime1 % 24);
        }
      }
      var result = "";
      if (theTime0 > 0) {
        result = "" + parseInt(theTime0) + "分" + result;
      }
      if (theTime1 > 0) {
        result = "" + parseInt(theTime1) + "小时" + result;
      }
      if (theTime2 > 0) {
        result = "" + parseInt(theTime2) + "天" + result;
      }
      return result;
    },
  },
};
</script>